/** "2026-08-25T21:30:00.000Z" → "2026-08-25 21:30 UTC" for the applied record. */
export const instant = (iso: string | null): string => (iso ? `${iso.slice(0, 10)} ${iso.slice(11, 16)} UTC` : '—');

/** "1 flight" / "2 flights" — the plural the alerts keep needing. */
export const flights = (count: number): string => `${count} flight${count === 1 ? '' : 's'}`;
